module.exports = __webpack_public_path__ + "static/media/26UNRWA12.6c4e39e4.jpg";